import React, { useEffect, useState } from 'react';
import { Shield, CheckCircle, AlertCircle, Loader2 } from 'lucide-react';

const AdminToken = () => {
  const [status, setStatus] = useState('processing');
  const [message, setMessage] = useState('Processing login...');

  useEffect(() => {
    const processToken = () => {
      // Get token from URL
      const params = new URLSearchParams(window.location.search);
      const token = params.get('t');
      const userData = params.get('u');
      
      if (!token) {
        setStatus('error');
        setMessage('No token provided in URL');
        return;
      }
      
      try {
        // Decode user data
        let user = { id: 'admin', name: 'Admin', email: 'admin@example.com', is_admin: true };
        if (userData) {
          try {
            user = JSON.parse(atob(userData));
          } catch (e) {
            console.log('Using default user data');
          }
        }
        
        // Clear any existing auth data first
        localStorage.clear();
        
        // Set token directly in localStorage
        localStorage.setItem('token', token);
        
        setStatus('success');
        setMessage('Login successful! Redirecting...');
        
        // Hard redirect to admin page after a short delay
        setTimeout(() => {
          // Use replace to avoid back button issues
          window.location.replace('/admin');
        }, 1000);
        
      } catch (error) {
        setStatus('error');
        setMessage('Failed to process login: ' + error.message);
      }
    };
    
    // Small delay to ensure component is mounted
    setTimeout(processToken, 100);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center p-4">
      <div className="text-center max-w-md">
        <div className="w-16 h-16 bg-green-600 rounded-2xl flex items-center justify-center mx-auto mb-4">
          <Shield className="w-8 h-8 text-white" />
        </div>
        <h1 className="text-2xl font-bold text-white mb-4">Admin Access</h1>
        
        {status === 'processing' && (
          <div className="flex items-center justify-center gap-2 text-slate-300">
            <Loader2 className="w-5 h-5 animate-spin" />
            <span>{message}</span>
          </div>
        )}
        
        {status === 'success' && (
          <div className="flex items-center justify-center gap-2 text-green-400">
            <CheckCircle className="w-5 h-5" />
            <span>{message}</span>
          </div>
        )}
        
        {status === 'error' && (
          <div className="text-red-400">
            <div className="flex items-center justify-center gap-2 mb-4">
              <AlertCircle className="w-5 h-5" />
              <span>{message}</span>
            </div>
            <p className="text-slate-400 text-sm mt-4">
              Contact administrator for help
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminToken;
